import React, { useState } from 'react';
import {
    Grid,
    useStyles,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import * as S from './AwardAccordion.style';
import type { AwardProps } from '@modules/page-builder/component/detail/banner-awards/types';
import CollapsibleContainer from './CollapsibleContainer';
import { AngleUp, AngleDown } from '@archipro-design/icons';

interface AwardAccordionProps {
    awards: AwardProps[];
}

export const AwardAccordion = ({ awards }: AwardAccordionProps) => {
    const [awardAccordionOpen, setAwardAccordionOpen] = useState(false);
    const { mobile } = useAppDisplayModeContext();

    const { css } = useStyles({ active: awardAccordionOpen });

    return (
        <div>
            <div
                className={css(S.AccordionTitleWrapper)}
                onClick={() => setAwardAccordionOpen((current) => !current)}
            >
                <span className={css(S.AccordionTitle)}>
                    Awards and Recognition
                </span>
                <div className={css(S.IconContainer)}>
                    {awardAccordionOpen ? (
                        <AngleUp className={css(S.AccordionIcon)} />
                    ) : (
                        <AngleDown className={css(S.AccordionIcon)} />
                    )}
                </div>
            </div>
            <CollapsibleContainer visible={awardAccordionOpen}>
                {mobile ? (
                    <div className={css(S.AccordionContainer)}>
                        {awards.map((p) => (
                            <div className={css(S.ProductAwardGrid)} key={p.id}>
                                <span className={css(S.AwardYear)}>
                                    {p.year}
                                </span>
                                <span className={css(S.AwardOrg)}>
                                    {p.institution}
                                </span>
                                <span className={css(S.AwardTitle)}>
                                    {p.title}
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={css(S.AccordionContainer)}>
                        {awards.map((p) => (
                            <Grid
                                className={css(S.ProductAwardGrid)}
                                key={p.id}
                            >
                                <span>{p.year}</span>
                                <span className={css(S.AwardOrg)}>
                                    {p.institution}
                                </span>
                                <span className={css(S.AwardTitle)}>
                                    {p.title}
                                </span>
                            </Grid>
                        ))}
                    </div>
                )}
            </CollapsibleContainer>
        </div>
    );
};
